// @flow
import React, { useEffect, useState } from 'react';
import type { Node } from 'react';
import Debug from 'debug';
import OlVectorSource from 'ol/source/Vector';
import type { Collection, Source } from '../types';
import { SourceProvider } from './context';

const debug = Debug('amms:modules:openlayers:sources:vector');

type Props = $ReadOnly<{
    features?: Collection,
    source?: Source,
    children: Node
}>;

function VectorSource({ features, source: externalSource, children }: Props) {
    const [source, setSource] = useState<?Source>();

    useEffect(() => {
        debug('Creating Vector source');
        const _source = externalSource || new OlVectorSource({
            features
        });

        setSource(_source);

        return () => {
           if(_source) {
               debug('Removing Vector source');

               setSource(null);
           }
        };
    }, [features, externalSource]);

    return (
        <SourceProvider source={source}>
            {children}
        </SourceProvider>
    );
}

export default VectorSource;